var _path, _path2, _path3, _linearGradient, _use, _use2, _radialGradient, _use3, _linearGradient2, _use4, _linearGradient3, _use5, _linearGradient4, _use6, _path4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFranceAmigo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 828.9 196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M741.8 19.9c-39.3 2.9-82.6 25.3-103.2 60.4 1.1-3 2.2-6.5 3.4-10.4l.2-.8c.1-.4.3-1 .6-1.7 3.8-11.5 5.4-18.1 3.2-22.3-2.2-4.4-7.8-5.5-10-5.8h-.6c-.5 0-13.3-.9-30.6 1.1-37.1 4.3-76.4 24.2-96.2 55.6l3.5-25.2c.3-1.5.4-2.9.4-4.2 7.8-6.1 13.8-14.4 15.7-24.5 1.8-9.2-.5-17.9-6.4-24.5-7.1-7.9-18.9-12.2-31.4-11.5-.8 0-1.6.1-2.3.2-10.5 1.1-21 5.2-29 11.4-8.9 6.8-14.4 15.7-15.5 25.1-.8 6.9.8 13.6 4.5 19.3-2.6-.7-5.3-.7-6.7-.6-.4 0-8.8.5-14.2 1-6.2.6-15.4 1.7-16.6 1.9-1.4.2-4.8.7-7.9 2.5s-5.9 5-7.2 6.7l-.1.1-.1.1c-6.7 9.1-13.6 17.5-18.7 23.6a170.44 170.44 0 0 0-5.1-9.1l-6.8-12c-.7-1.3-1.9-3.5-3.8-4.8-1.8-1.2-4.4-1.6-5.7-1.8h-.9c-.4 0-9.1.3-14.8.8s-14.2 1.8-15.6 2c-1.9.2-6.1 1.1-9.2 4.5-3.2 3.5-4 8.3-4.2 10.4v.3l-.6-5c-.1-1.8-.5-4-1.7-5.4-2.1-2.6-5.1-2.5-7-2.4-1.3 0-10.5.1-15 .4-4.4.2-13.8 1.2-15.2 1.3a15.72 15.72 0 0 0-8 2.5c-3.3 2.1-5.2 4.8-6.4 6.5l-.4.6-.1.2-.1.1c-.2.2-.6.8-1.2 1.7-3.9 5.5-14.3 20.4-22.5 32.9l-25.6 38.5-.1.2-.1.2c-4.4 6.9-4 11-3.4 12.7.8 2.6 8.1 13.8 8.1 13.8h482.6c2.2.2 4.5.7 6.7.7 6.5.1 13.1-.4 19.6-1.4 1.5-.1 2.5-.3 3.1-.4s1.1-.3 1.7-.5c45.9-9.2 87.6-44.8 96.9-87.5 11.4-52.5-33.9-80.9-80-77.5zM631.7 95l-.3.9h-.4c.2-.3.4-.6.7-.9z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M478.8 56.5c-13.1-.3-24.3-9.1-22.8-21.1 1.7-12.7 16.5-22.2 31.3-23.6 15.2-1.4 29.2 7 26.2 21.4-3 14.3-19.9 23.7-34.7 23.3zM303.4 84.4s-.1-2.4-.7-3.2c-.8-1-1.8-1-3.3-.9l-15.1.3c-4.6.2-15.2 1.3-15.2 1.3-1.3.1-2.6.3-4 1.1-1.4.9-2.2 2.3-3.2 3.9 0 .1-13.2 19.9-22.5 35.2L216 160c-1 1.7-1.9 3.8-1.5 5 .3.9 2.2 1.3 2.2 1.3s3 .4 9.6.5 11.8-.3 11.8-.3 1.6.3 2.8-.6c1.6-1.1 3.3-6.8 5.1-7.9 1.1-.6 2.1-.4 2.1-.4s3.1 1 5.7 1c3.3 0 7.4-.9 7.4-.9s1.1-.3 1.6.5c1.1 1.7-1 5.6.5 7.4.6.6.9 1 3.2.8-.1 0 8 .7 15.5.5l16.9-.5c.8-.1 2.5-.9 3.3-2 1.3-1.9 1.2-4.8 1.2-4.8s2-23.5 1.8-40.5c.3-16.6-1.8-34.7-1.8-34.7zm-37.8 57c-1.4 1.7-5.1 2-6.4 2-1.4 0-4.8-.1-5.1-1.8-.2-.9.3-2.2 1.3-3.9l5.2-9c1.1-2 2.6-4.4 4.2-4.4s1.6 2.2 1.6 3.8l.2 9c0 2.2-.1 3.3-1 4.3zm369-39.6-17.4.7-23.4 1.3s-2.4.3-3.6 1.4c-1.7 1.4-2.8 3.2-2 4.5s3.6 2.3 3 4.9c-.8 3.7-2 8.4-3.1 9.8-2.1 2.5-5.6 2.8-8.9 3-7 .3-19.8-4.8-17-16.5 2.9-12.2 16.6-20.6 32.2-21.7 8.6-.6 21.2.9 21.2.9s3.4.3 5.2-1c3.5-2.4 7.1-19.3 7.8-22 .7-2.9 4-14.1 2.5-16.6-1-1.7-4.5-2.2-4.5-2.2s-11.6-.9-27.1.7c-37.7 4-78.8 26.5-87.6 64.4-8.6 37.1 26 55 60.9 54.8 27.8-.1 47-13.5 47-13.5s3.4-2.1 4.9-3.6c1.2-1.2 2.5-4 2.5-4s4.2-14.2 6.4-23.3l4-17s.4-2.6-.2-3.5c-.7-1-2.8-1.5-2.8-1.5zm97.3-65.9c-38.7 2.5-80.3 28.2-86.9 66.1-6.6 38.1 25.6 66.4 64 66.5 41.5 0 85.8-30.1 91.2-72.1 5.1-39.4-30.1-62.9-68.3-60.5zM440 68.1s-8.3.4-13.6.9c-6.3.5-16 1.6-16 1.6s-2.4.2-3.9 1S403 75 403 75c-7.3 9.9-14.9 19.1-21 26.4 0 0-2.6 3.9-4.7 4-2 .1-3.8-2.9-3.8-2.9l-7.1-12.1-7.1-11.8s-.9-1.8-1.9-2.5c-.9-.6-3.1-.8-3.1-.8s-8.8.2-14.3.7c-5.9.5-15.2 1.8-15.2 1.8s-2.8.2-4 1.5-1.4 4.2-1.4 4.2l-4.5 39.6-3.5 39.4s-.3 2.2.8 3.4c.7.8 3.3.7 3.3.7s7.3.5 12 .5c4.3 0 11-.4 11-.4s3.5.1 5.1-1.2c1.2-1 1.2-3.1 1.2-3.1l1.1-10.9s0-3.4 2-3.4c1.9 0 2.9 1.5 3.1 2.2l8.4 17s2.4 3.9 4.9 3.9c2.6 0 6.1-4.2 6.1-4.2l14.2-16.5c1.5-1.8 3.3-4 5.2-3.1s1 4.5 1 4.5l-1.4 10.3s-.5 2.6.7 3.6c1 .8 5.5.8 5.5.8s9.9.7 16.3.7 16.4-.9 16.4-.9 2.6 0 3.7-1c1.3-1.1 1.7-3.9 1.7-3.9l7.2-44.9 5.9-41.9s.7-3.9-.8-5.4c-1.4-1.5-6-1.2-6-1.2zm58.4-5.8-16.4.5c-5.9.3-17.3 2.3-17.3 2.3s-1.8 0-3.8 1.7c-1.7 1.6-2.1 5.5-2.1 5.5l-6.2 39.3c-2.5 17.9-4.7 47.7-4.7 47.7s-.9 4.7.6 6.2c1.5 1.6 4.4 1.4 4.4 1.4s9.6.4 16.5.4c7.2 0 16.3-.5 16.3-.5s3.2 0 4.7-1.8c1.3-1.6 1.6-4.9 1.7-6.2l6.3-48.6 4.1-41s.6-4.4-.5-5.6c-1.4-1.5-3.6-1.3-3.6-1.3z",
    fill: "#c20e1a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M718.2 152c-25.8 1.5-41.9-20.3-42.5-21.2-.7-1-.8-2.3-.3-3.3.4-.8 1.1-1.2 1.9-1.3.3 0 .5 0 .8.1.1 0 6.9 2 19.3 1.1 6.9-.5 14.3-1.8 22-3.8 26.9-7.1 49-34.2 49.2-34.5.5-.6 1.1-.9 1.8-1 .4 0 .9.1 1.4.3 1.1.6 1.8 1.8 1.7 3.1 0 .5-.9 12.8-7.4 26.4-6 12.5-18 28.4-41.3 33.3-2.2.4-4.4.7-6.6.8zM112.3 15.3l64.2 64.5c9.9 9.9 9.9 25.9 0 35.8l-64.2 64.5c-9.9 9.9-25.9 10-35.9.1l-64.8-64.5c-9.9-9.9-9.9-26 0-35.9l64.8-64.5c10-9.9 26-9.9 35.9 0z",
    fill: "#fff"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 174.111,
    y1: 97.7,
    x2: 6.959,
    y2: 97.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#49bbec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1281c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#096db3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#095da7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#09559e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08529c"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "url(#b)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#08509a"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 170.366,
    cy: 2191.846,
    r: 108.048,
    gradientTransform: "matrix(1 0 0 -1 .003 2289.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2fabe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#2aa5de",
    stopOpacity: 0.821
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#2196d4",
    stopOpacity: 0.591
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#167ec2",
    stopOpacity: 0.334
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#0d5aa4",
    stopOpacity: 0.058
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08529c",
    stopOpacity: 0
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "url(#c)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 128.271,
    y1: 63.719,
    x2: 139.626,
    y2: 52.46
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07539d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07539d"
  }))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "url(#d)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 127.927,
    y1: 132.31,
    x2: 139.121,
    y2: 143.728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07539d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07539d"
  }))), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "url(#e)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 164.935,
    y1: 95.235,
    x2: 177.021,
    y2: 94.816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07539d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07539d"
  }))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "url(#f)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.3 78.4c-.4-1.1-.1-18.5-12.5-20.1-8.1-1.1-15.5 4.4-21.1 11.4l24.8 12-11.9 24.8c8.9 1.9 18.2 1.5 23.9-4.6 8.6-9.2-2.7-22.5-3.2-23.5zm-48.6 24.3c-5.1 2.3-21.7 34.8-7.7 48 9.1 8.6 22.4-2.6 23.5-3s18.5.1 20.3-12.4c2.7-19.1-30.6-33.9-36.1-32.6zm-4.1-11.6c5.1-2.3 21.8-34.8 7.7-48-9.1-8.6-22.4 2.6-23.5 3S59.3 46 57.6 58.4c-2.7 19.2 30.6 34 36 32.7zm-4 7.7c-2.4-5.1-34.8-21.7-48-7.7-8.6 9.1 2.6 22.4 3 23.5.3 1.1-.1 18.5 12.3 20.3 19.2 2.6 34.1-30.7 32.7-36.1zm-28.3 50 6.7 6.7c4.4-4.6 10-12.4 12.2-24.1-.5-.2-3.6-.5-3.9-.7-3.4 9.1-9.9 14.8-15 18.1z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m100.13 94.884 10.94-22.813 22.813 10.94-10.94 22.813z",
    fill: "#e01f26"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 121.116,
    y1: 80.203,
    x2: 122.502,
    y2: 77.361
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.029,
    stopColor: "#e01f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#a61e22"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.7 74.7 111 72l22.9 10.9-1.3 2.7z",
    fill: "url(#g)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 108.422,
    y1: 84.757,
    x2: 105.443,
    y2: 83.368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.029,
    stopColor: "#e01f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#a61e22"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.1 94.8 111 72l2.8 1.3-11 22.8z",
    fill: "url(#h)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 114.353,
    y1: 79.61,
    x2: 112.223,
    y2: 71.663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e01f26",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#a61e22"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.4 77.4 111 72l-4.7 9.8z",
    fill: "url(#i)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m16.4 84.4 64.3-64.3c7.3-7.3 19.2-7.3 26.6 0l64.3 64.3c7.3 7.3 7.3 19.2 0 26.6l-64.3 64.3c-7.3 7.3-19.2 7.3-26.6 0L16.4 111c-7.3-7.3-7.3-19.2 0-26.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranceAmigo);
export default __webpack_public_path__ + "static/media/france_amigo.d17e3df6c960b3724916bdeb80246e5f.svg";
export { ForwardRef as ReactComponent };